import { useUserContext } from "@/providers";
import { useEffect, useState } from "react";
import { useDynamicFormContext } from "../DynamicFormProvider";

export const useCheckEditableFormField = ({ editableByStatus, property }) => {
  const {
    formConfig,
    formRef,
    formData,
    getDependentPropertyValue,
    getDependentPropertyField,
    currentStatus,
    handleValuesChange,
    calculatedFields,
  } = useDynamicFormContext();
  const { hasRight } = useUserContext();

  const [isDisabled, setIsDisabled] = useState(
    editableByStatus && !!Object.keys(editableByStatus).length
  );

  useEffect(() => {
    if (
      !editableByStatus ||
      !Object.keys(editableByStatus)?.length ||
      !currentStatus
    ) {
      setIsDisabled(false);
    } else {
      //If any other status has rights assigned to it, the lack of rights for your status
      //means you do not have access to write the field.
      const editable = property.editableByStatus?.[currentStatus]?.filter(
        (status) => hasRight([status])
      ).length;
      setIsDisabled(!editable);
    }
  }, [currentStatus, editableByStatus, hasRight, property.editableByStatus]);

  return {
    isDisabled,
    formConfig,
    formRef,
    formData,
    getDependentPropertyValue,
    getDependentPropertyField,
    handleValuesChange,
    calculatedFields,
  };
};
